/**
 * @file MlrEditorChromePortal.tsx
 * @brief Mount the MLR format/save row into the page-level sticky strip.
 *
 * @details
 * Sticky inside the A4 CSS grid looked like a hanging chip over the paper.
 * The host lives on MedicalAssessmentDetailPage so the frosted bar pins to
 * the shell scroller (08-09-2026).
 *
 * @author DES
 * @date 08-09-2026
 */

import { useLayoutEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

export const MLR_EDITOR_CHROME_ID = "mlr-editor-chrome";

export function MlrEditorChromePortal({ children }: { children: ReactNode }) {
  const [host, setHost] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    setHost(document.getElementById(MLR_EDITOR_CHROME_ID));
  }, []);

  if (!host) return null;
  return createPortal(children, host);
}
